@for (assignment of localAssignments; track assignment; let index = $index) {
  <div class="assignment-row">
    <!-- State Selection -->
    <mat-form-field appearance="outline" class="state-field">
      <mat-label>State</mat-label>

      <mat-select
        [(ngModel)]="assignment.state"
        (selectionChange)="onStateChange(index)"
      >
        @for (state of states; track state.value) {
          <mat-option
            [value]="state.value"
            [disabled]="isStateDisabled(state.value, index)"
          >
            {{ state.name }}
          </mat-option>
        }
      </mat-select>
      @if (!assignment.state) {
        <mat-error> State Required </mat-error>
      }
    </mat-form-field>
    <!-- Dealer Selection -->
    <mat-form-field appearance="outline" class="dealer-field">
      <mat-label>Dealers</mat-label>

      <mat-select
        #dealerSelect
        multiple
        [(ngModel)]="assignment.dealers"
        (selectionChange)="onDealerChange(dealerSelect)"
        panelClass="dealer-panel"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="dealerCodeFilterCtrl"
            placeholderLabel="Search Dealer"
            noEntriesFoundLabel="No dealer found"
          >
          </ngx-mat-select-search>
        </mat-option>

        @for (dealer of filteredDealers(assignment.state); track dealer) {
          <mat-option [value]="dealer">
            {{ dealer }}
          </mat-option>
        }
      </mat-select>

      @if (assignment.state && assignment.dealers.length === 0) {
        <mat-hint> No dealers selected = All Dealers </mat-hint>
      }
    </mat-form-field>
    <!-- Remove -->
    <button
      mat-icon-button
      color="warn"
      type="button"
      (click)="removeState(index)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
}

<div class="assignment-footer">
  <button mat-raised-button color="primary" type="button" (click)="addState()">
    <mat-icon>add</mat-icon>
    Add State
  </button>
</div>
